import { render, staticRenderFns } from "./CollegeMajor.vue?vue&type=template&id=b8679468&scoped=true&"
import script from "./CollegeMajor.vue?vue&type=script&lang=js&"
export * from "./CollegeMajor.vue?vue&type=script&lang=js&"
import style0 from "./CollegeMajor.vue?vue&type=style&index=0&id=b8679468&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8679468",
  null
  
)

export default component.exports